module.exports = __webpack_public_path__ + "static/media/newsletter-signup.ba91d546.png";